<template>
    <div :id="id" class="d-flex align-items-center">
        <font-awesome-icon
            :icon="icon"
            :size="size"
            class="ml-1 mr-1"
        ></font-awesome-icon>
        <b-tooltip :target="id" triggers="hover" :variant="variant" container="vue-app">
            <slot></slot>
        </b-tooltip>
    </div>
</template>

<script>
    export default {
        name: 'FaIconTooltip',
        props: {
            id: String,
            icon: [Object, Array, String],
            variant: {
                type: String,
                default: null,
            },
            size: {
                type: String,
                default: 'lg',
            },
        },
    };
</script>

<style lang="scss" scoped>
.tooltip {
    opacity: 1 !important;
}
</style>
